import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";

export const QrScanner = ({ onResult }) => {
  const [error, setError] = useState(null);
  const done = useRef(false);

  useEffect(() => {
    const scanner = new Html5Qrcode("qr-reader");
    let started = false;
    scanner
      .start({ facingMode: "environment" }, { fps: 10, qrbox: { width: 240, height: 160 } }, (text) => {
        if (done.current) return;
        done.current = true;
        onResult(text);
      })
      .then(() => { started = true; })
      .catch(() => setError("Camera not available. Enter the code manually below."));
    return () => {
      if (started) scanner.stop().catch(() => {});
    };
  }, [onResult]);

  return (
    <div className="space-y-2">
      <div id="qr-reader" data-testid="qr-reader" className="overflow-hidden rounded-md border border-slate-700 bg-black min-h-[200px]" />
      {error && <p className="text-sm text-amber-300" data-testid="qr-error">{error}</p>}
    </div>
  );
};
